// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';

// if (environment.production) {
//   enableProdMode();
// }

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.log(err));


import { enableProdMode, APP_INITIALIZER, ErrorHandler, importProvidersFrom, ENVIRONMENT_INITIALIZER, inject, provideEnvironmentInitializer } from '@angular/core';

import { AppModule, ConfigLoader } from './app/app.module';
import { environment } from './environments/environment';
import { IConfigService } from './app/config/iconfigservice';
import { ConfigService } from './app/config/config.service';
import { AppService } from './app/app.service';
import { AuthLegacyService } from './app/auth/auth-legacy.service';
import { InterviewService } from './app/interview.service';
import { InterviewSectionActionService } from '@Services/case/interview-section-action.service';
import { AccountInterviewService } from './app/account/account-config/account-interview/account-interview.service';
import { MonitoringService } from './app/monitor.service';
import { DatePipe, CurrencyPipe, CommonModule } from '@angular/common';
import { BraintreeIntegrationResponseHandler } from './app/interview/handlers/braintree/braintree-integration-response-handler.component';
import { SbliOneIncPaymentIntegrationHandler } from 'app/interview/handlers/oneinc/sbli-oneincpayment-integration-handler.component';
import { AuraIntegrationResponseHandler } from './app/interview/handlers/aura/aura-integration-response-handler.component';
import { TrustCommerceIntegrationResponseHandler } from './app/interview/handlers/trustcommerce/trustcommerce-integration-response-handler.component';
import { StripeIntegrationResponseHandler } from './app/interview/handlers/stripe/stripe-integration-response-handler.component';
import { PrimorisIntegrationResponseHandler } from './app/interview/handlers/primoris/primoris-integration-response-handler.component';
import { EndOfInterviewHandler } from './app/interview/end-of-interview/end-of-interview-handler.component';
import { BaseFormFieldServices } from './app/components/form-fields/base-interview-form-field/base-interview-form-field.component';
import { InterviewManagerService} from '@Interview';
import { SbliOneIncPaymentService } from '@Services/case/sbli-one-inc-payment.service';
import { NewBusinessWorkbenchService } from './app/new-business-workbench/services/new-business-workbench.service';
import { NewBusinessWorkbenchStateService } from './app/new-business-workbench/services/new-business-workbench-state.service';
import { FileUploadService, FeatureManagerService, AccountDataService, AccountEventsService, AccountService, AccountSettingsDataService, AccountSettingsService, ApiMappingsService, BraintreeService, CallManagerService, CaseAssigneeService, CaseAttachmentService, CaseDocumentsDataService, CaseDynamicListMapkeyService, CaseImportExportService, CaseMapKeyService, CaseNotificationsService, CaseSearchService, CaseSignatureService, CaseSummaryService, ClientDataService, ClientService, ConfirmationDialogService, ConstantMapKeyService, DashboardService, DocumentsService, EnvironmentService, FeatureToggleService, GlobalService, IdleService, ImportExportService, IntegrationService, InterviewClientDefaultsService, InterviewDataService, IpAddressService, LocalDataService, LookupService, MagnumService, ManagementQueueService, MapkeysDataService, MapKeyService, NotificationService, ObservableService, QuestionService, ReportDownloadService, RoutingService, RulesService, SectionApiSettingsService, SectionDataService, SectionService, SignalRService, SignerService, StripeService, SystemEventService, TagService, ThemeService, TrustCommerceService, UserAdminService, WhiteLabelService, UtilityService, UWTaskService } from '@Services';
import { CaseMetricService } from './app/components/case-metrics-v2/services/case-metrics.service';
import { ThirdPartySectionService } from './app/components/third-party-section/third-party-section.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { MonitoringErrorHandler } from './app/error.handler';
import { CanNavigateAwayWithConfirmGuard, CanNavigateAwayWithConfirmGuardAccountConfig } from './app/new-business-workbench/guards/canNavigateAway.guard';
import { CanActivateCnbw } from './app/new-business-workbench/guards/canActivateCnbw.guard';
import { SecondsToTimePipe } from '@Pipes/secondstotime.pipe';
import { BrowserModule, DomSanitizer, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { TreeModule } from 'primeng/tree';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { ContextMenuModule } from 'primeng/contextmenu';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DatePickerModule } from 'primeng/datepicker';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { AuthorizationModule } from './app/authorization/authorization.module';
import { PrimorisModule } from './app/components/primoris-embedded/primoris.module';
import { MrasAppModule } from '@Components/mras/mras-app.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppRoutingModule } from './app/app-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatBadgeModule } from '@angular/material/badge';
import { AppComponent } from './app/app.component';
import InterviewProgressService from '@Interview/components/interview-progress/interview-progress.service';
import { CookieInterceptor, NotificationInterceptor, LocalTimeInterceptor } from '@App/interceptors';
import { AccountResolverService, AccountsResolverService, ActiveAccountResolverService, ClientResolverService, ClientsResolverService, WhiteLabelThemeResolver, InterviewResolverService } from '@Services/resolvers';
import { AccountSettingGuard, AclGuardService, AuthGuardService, AuthV2GuardService, CanDeactivateGuardService, ClientGuardService, FeatureFlagGuard, FeatureToggleGuard, RedirectGuard, RoleGuard, ValidCaseGuard, ValidThemeGuard } from '@Services/guards';
import { SidenavService } from '@Shared/services/sidenav.service';
import { TableDataService } from '@Shared/services/table-data.service';
import { SharedModule } from 'primeng/api';
import Aura  from '@primeuix/themes/aura';
import { UWDecisionServices, UWNotesFeatureToggleDataService } from '@CaseSummary/underwriting/services';
import { CaseHistoryService } from '@CaseSummary/caseHistory/case-history.service';
// Update the path below to the correct relative path to theme.ts
import themePreset from './app/utils/theme';
import { RemoveHtmlTagsPipe } from '@Pipes/removehtmltags.pipe';
import { TranzpayIntegrationResponseHandler } from '@Interview/handlers/tranzpay/tranzpay-integration-response-handler.component';
import { Input1IntegrationResponseHandler } from '@Interview/handlers/input1/input1-integration-response-handler.component';
import { SidebarService } from '@CaseSummary/sidebar/sidebar.service';
import { Input1Service } from '@Components/input1/input1.service';
import { IllustrataIntegrationResponseHandler } from '@Interview/handlers/illustrata/illustrata-integration-response-handler.component';
import { IllustrataService } from '@Services/case/illustrata.service';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, HttpClientModule, ConfirmDialogModule, DialogModule, TreeModule, NgxDocViewerModule, ContextMenuModule, TableModule, FileUploadModule, AutoCompleteModule, DatePickerModule, ProgressSpinnerModule, NgxExtendedPdfViewerModule, AngularEditorModule, MatIconModule,
        CommonModule,
        SharedModule,        
         AuthorizationModule.forRoot(), PrimorisModule.forRoot(), MrasAppModule, DragDropModule, AppRoutingModule, MatDialogModule, MatTableModule, MatSortModule, MatBadgeModule),
        { provide: IConfigService, useClass: ConfigService },
        { provide: APP_INITIALIZER, useFactory: ConfigLoader, deps: [IConfigService], multi: true },
        AppService,
        AuthLegacyService,
        InterviewService,
        InterviewSectionActionService,
        AccountInterviewService,
        ReportDownloadService,
        MonitoringService,
        DatePipe,
        BraintreeIntegrationResponseHandler,
        SbliOneIncPaymentIntegrationHandler,
        AuraIntegrationResponseHandler,
        TrustCommerceIntegrationResponseHandler,
        StripeIntegrationResponseHandler,
        PrimorisIntegrationResponseHandler,
        TranzpayIntegrationResponseHandler,
        Input1IntegrationResponseHandler,
        IllustrataIntegrationResponseHandler,
        EndOfInterviewHandler,
        BaseFormFieldServices, // form-field
        AccountDataService,
        ClientDataService,
        DashboardService,
        ManagementQueueService,
        CaseSummaryService,
        ConfirmationDialogService,
        EnvironmentService,
        IdleService,
        InterviewClientDefaultsService,
        RoutingService,
        WhiteLabelService,
        ThemeService,
        NotificationService,
        RulesService,
        SignalRService,
        LookupService,
        FeatureToggleService,
        IntegrationService,
        AccountEventsService,
        AccountSettingsService,
        SectionApiSettingsService,
        SectionService,
        DocumentsService,
        ApiMappingsService,
        CaseSearchService,
        CaseSignatureService,
        SignerService,
        ImportExportService,
        CaseImportExportService,
        CaseNotificationsService,
        MapKeyService,
        CaseMapKeyService,
        CaseDynamicListMapkeyService,
        ObservableService,
        AccountService,
        TagService,
        CallManagerService,
        CaseAttachmentService,
        SystemEventService,
        GlobalService,
        ClientService,
        ConstantMapKeyService,
        SystemEventService,
        CaseAssigneeService,
        BraintreeService,
        LocalDataService,
        IpAddressService,
        TrustCommerceService,
        Input1Service,
        MagnumService,
        StripeService,
        QuestionService,
        UserAdminService,
        CaseDocumentsDataService,
        AccountSettingsDataService,
        SectionDataService,
        InterviewDataService,
        MapkeysDataService,
        InterviewProgressService,
        InterviewManagerService,
        SbliOneIncPaymentService,
        NewBusinessWorkbenchService,
        NewBusinessWorkbenchStateService,
        FileUploadService,
        CaseMetricService,
        ThirdPartySectionService,
        UtilityService,
        FeatureManagerService,
        SidebarService,
        UWNotesFeatureToggleDataService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CookieInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: NotificationInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LocalTimeInterceptor,
            multi: true
        },
        providePrimeNG({
            theme: {
                preset: themePreset,
                options: {
                    darkModeSelector: false || 'none'
                }
            }
        }),
        // {
        //   provide: HTTP_INTERCEPTORS,
        //   useClass: CacheInterceptor,
        //   multi: true
        // },
        AccountResolverService,
        AccountsResolverService,
        ActiveAccountResolverService,
        ClientResolverService,
        ClientsResolverService,
        WhiteLabelThemeResolver,
        InterviewResolverService,
        {
            provide: ErrorHandler,
            useClass: MonitoringErrorHandler
        },
        FeatureToggleGuard,
        RedirectGuard,
        CanNavigateAwayWithConfirmGuard,
        CanNavigateAwayWithConfirmGuardAccountConfig,
        CanActivateCnbw,
        SecondsToTimePipe,
        CurrencyPipe,
        TableDataService,
        SidenavService,
        CanDeactivateGuardService,
        ClientGuardService,
        ValidThemeGuard,
        RoleGuard,
        AclGuardService,
        AuthGuardService,
        FeatureFlagGuard,
        AuthV2GuardService,
        ValidCaseGuard,
        AccountSettingGuard,
        UWDecisionServices,
        CaseHistoryService,
        RemoveHtmlTagsPipe,
        UWTaskService,
        IllustrataService,
        provideAnimations(), // Or other animation providers
        provideEnvironmentInitializer(() => {
            const matIconRegistry = inject(MatIconRegistry);
            const domSanitizer = inject(DomSanitizer);

            // Or register an SVG icon set
            matIconRegistry.addSvgIconSet(
              domSanitizer.bypassSecurityTrustResourceUrl('assets/mdi.svg')
            );
        })
    ]
})
    .catch(err => console.log(err));
